import { mapState } from 'vuex';

import { Errors } from '@/enums/errors.enum';
import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import { tryParseInt } from '@/utils/number';

/**
 * Mixin do edycji/dodawania encji
 *
 * @export
 * @param {string} moduleName - nazwa modułu
 * @returns
 */
export function editMixin(moduleName) {
  return {
    mixins: [formMixin, notificationsMixin],
    data() {
      return { model: {} };
    },
    computed: {
      ...mapState({ stateData: state => state[moduleName].data }),
      id() {
        return tryParseInt(this.$route.params[`${moduleName}Id`]);
      }
    },
    methods: {
      // @vuese
      // Ustawia dane formularza
      setData(data) {
        this.$schema.$setData(data);
      },

      // @vuese
      // Przetwarza formularz
      submit() {
        if (this.$schema.$validateAll().length !== 0) {
          return this.notifyError(Errors.FORM_CORRECT_ERRORS);
        }

        this.save();
      },
      // @vuese
      // Funkcja wywoływana po wykonaniu zapisu
      afterSave(id) {},

      // @vuese
      // Zapisuje dane
      save() {
        const model = { ...this.$schema.$getData(), id: this.id };
        const action = this.id ? 'update' : 'add';
        this.$store
          .dispatch(`${moduleName}/${action}`, this.prepareModel(model))
          .then(entityId => this.afterSave(entityId))
          .catch(err => this.notifyError(Errors.FORM_CANNOT_SAVE));
      },

      // @vuese
      // Funkcja mapująca model przed zapisem
      prepareModel(model) {
        return model;
      }
    },
    mounted() {
      if (this.stateData) {
        this.setData(this.stateData);
      }
    }
  };
}
